import { render, staticRenderFns } from "./GridSeleccionDesasociar.vue?vue&type=template&id=33383a30&"
import script from "./GridSeleccionDesasociar.vue?vue&type=script&lang=ts&"
export * from "./GridSeleccionDesasociar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('33383a30', component.options)
    } else {
      api.reload('33383a30', component.options)
    }
    module.hot.accept("./GridSeleccionDesasociar.vue?vue&type=template&id=33383a30&", function () {
      api.rerender('33383a30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Asignaciones/GridSeleccionDesasociar.vue"
export default component.exports